<template>
  <div class="container py-4 col-12 col-lg-10" id="container">

    <!-- TÍTULO -->
    <!-- BREADCRUMB -->
      <!-- <nav class="mt-3 mb-3 mb-md-5" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="/"><b>Início</b></a></li>
          <li class="breadcrumb-item active" aria-current="page">Editar perfil</li>
        </ol>
      </nav> -->

      <!-- TÍTULO -->
      <div class="row mb-md-5 page-header">
        <div class="col-12">
          <p class="page-header-eyebrow">PERFIL</p>
          <h1 class="page-title mb-1">Editar perfil</h1>
          <p class="page-subtitle mb-0">
            Edite as informações do seu perfil.
          </p>
        </div>
      </div>

    <!-- CARD -->
    <div class="row">

      <div class="perfil-card col-12 mx-auto" v-if="usuarioLogado">

        <!-- HEADER -->
        <div class="perfil-header mb-5" v-if="usuarioLogado">
          <div class="avatar-wrapper">
            <div class="avatar">{{ iniciaisUsuario }}</div>
          </div>

          <div class="text-center mt-2">
            <b>{{ usuarioLogado.nome }}</b>
            <div class="text-muted small">{{ usuario.email }}</div>
          </div>
        </div>

        <!-- FORM -->
        <form @submit.prevent="editarUsuario">

          <!-- TÍTULO DA SESSÃO -->
          <h5 class="titulo-sessao mb-3">Informações pessoais</h5>

          <div class="mb-3">
            <label class="form-label">Seu nome</label>
            <input
              type="text"
              class="form-control"
              v-model="usuario.nome"
              required
            />
          </div>

          <div class="mb-4">
            <label class="form-label">CPF</label>
            <input
              type="text"
              class="form-control"
              v-model="usuario.cpf"
            />
          </div>


          <div class="mb-3">
            <label class="form-label">Empresa</label>
            <input
              type="text"
              class="form-control"
              v-model="usuario.empresa"
              required
            />
          </div>

          <!-- TÍTULO DA SESSÃO -->
          <h5 class="titulo-sessao mb-3 mt-5">Informações de contato</h5>

          <div class="mb-3">
            <label class="form-label">Telefone</label>
            <div class="campo-senha mb-3">
            <img
                src="../img/tel-icon.svg"
                class="icone cadeado"
                alt="E-mail"
            />
              <input
                type="text"
                class="form-control"
                v-model="usuario.celular"
                required
              />
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label">E-mail</label>
            <div class="campo-senha mb-3">
              <img
                  src="../img/email-icon.svg"
                  class="icone cadeado"
                  alt="E-mail"
              />
              <input
                type="email"
                class="form-control" id="emailNovo"
                v-model="usuario.email"
                required
              />
            </div>
          </div>

          <div class="text-end mt-3">
            <button type="submit" class="btn btn-primary botao-azul w-100">
              Salvar alterações
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>

  <!-- MODAIS -->
  <AlertModal
    :visible="alertModal.visible"
    :title="alertModal.title"
    :message="alertModal.message"
    :type="alertModal.type"
    @close="fecharAlert"
  />

  <LoadingModal
    :visible="loading.visible"
    :title="loading.title"
    :message="loading.message"
  />

</template>

<script>

import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { getUsuario, setUsuario } from '@/utils/authStorage';

export default {
  name: "EditarUsuario",
  data() {
    return {
      usuario: {
        nome: "",
        celular: "",
        empresa: "",
        email: "",
        emailAtual: ""
      },
      usuarioAtual: {},
      usuarioLogado: null,

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info',
        recarregarAoFechar: false
      },

      // Modal de loading
      loadingModal: null,
      loadingModalAberto: false,

      // Modal de loading
      loading: {
        visible: false,
        title: 'Carregando dados',
        message: 'Aguarde um momento...'
      }
    };
  },

  components: {
    AlertModal,
    LoadingModal
  },

  computed: {
    iniciaisUsuario() {
      if (!this.usuario.nome) return "";
      return this.usuario.nome
        .split(" ")
        .map(p => p[0])
        .join("")
        .substring(0, 2)
        .toUpperCase();
    }
  },

  mounted() {
    
    this.usuarioLogado = getUsuario();
    this.ajustarTamanhoCardPrincipal();
    this.abrirLoading();
    this.carregarUsuario();
  },

  methods: {
    abrirAlert(title, message, type = 'info', recarregarAoFechar = false) {
      this.alertModal = {
        visible: true,
        title,
        message,
        type,
        recarregarAoFechar
      };
    },

    fecharAlert() {
      const recarregarAoFechar = this.alertModal.recarregarAoFechar;
      this.alertModal.visible = false;

      if (recarregarAoFechar) {
        location.reload();
      }
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    ajustarTamanhoCardPrincipal(){
      const card = document.querySelector(".card-principal");
      if (card) {
        card.style.maxWidth = "800px";
      }
    },

    async carregarUsuario() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/buscar-usuario`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: this.usuarioLogado.email })
          }
        );

        if (response.status === 404) {
          this.abrirAlert("Sistema", "Usuário não encontrado.", "error");
          return;
        }

        const data = await response.json();
        this.usuario = data.usuario;

        // Atualiza o campo de email com o valor atual
        this.usuario.emailAtual = this.usuario.email;
        this.usuarioAtual = { ...this.usuario };

      } catch (err) {
        console.error("Erro ao carregar usuário:", err);
        this.abrirAlert(
          "Sistema",
          "Erro ao carregar dados do usuário.",
          "error"
        );
      } finally {
        this.fecharLoading();
      }
    },

    async editarUsuario() {

      if (!this.usuario.nome || !this.usuario.celular || !this.usuario.empresa || !this.usuario.email) {
        this.abrirAlert("Sistema", "Por favor, preencha todos os campos.", "error");
        return;
      }

      if(this.usuarioAtual.nome === this.usuario.nome && this.usuarioAtual.celular === this.usuario.celular && this.usuarioAtual.empresa === this.usuario.empresa && this.usuarioAtual.email === this.usuario.email) {
        this.abrirAlert("Sistema", "Nenhuma alteração detectada.", "info");
        return;
      }

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/editar-usuario`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(this.usuario)
          }
        );

        if (!response.ok) {
          const erro = await response.json();
          throw new Error(erro.message || "Failed to update user.");
        }

        if(response.status === 200) {
          const data = await response.json();
          const usuarioAtual = getUsuario() || {};

          const usuarioAtualizado = {
            ...usuarioAtual,
            nome: data.usuario.nome,
            email: data.usuario.email,
            tipo: usuarioAtual.tipo || 'usuario'
          };

          setUsuario(usuarioAtualizado);
          this.usuarioLogado = usuarioAtualizado;

          this.abrirAlert("Sistema", "Dados atualizados.", "success", true);

        }

      } catch (err) {
        console.error("Error to update user:", err);
        this.abrirAlert("Sistema", "Error to update user. Try again later.", "error");
      }
    }

  }
};
</script>

<style>
.titulo h2 {
  color: #001232BF;
  font-size: 22px;
  font-weight: 600;
}

.perfil-card {
  background: #ffffff;
  border: none;
  border-radius: 12px;
}

.botao-azul {
  background-color: #0056FF;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 700;
  border: none;
}

.botao-azul:hover {
  background-color: #000000;
}

.titulo-sessao {
  color: #0056FF;
  font-size: 16px;
  font-weight: 800 !important;
  letter-spacing: 0.01em;
}

.perfil-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 28px 0 24px;
}

.avatar-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 64px;
  height: 64px;
  aspect-ratio: 1 / 1;
  background-color: #EDF7FF;
  color: #0056FF;
  border-radius: 50%;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}

.campo-com-icone {
  position: relative;
}

/* Ícone à direita */
.icone-direita {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  opacity: 0.6;
  pointer-events: none; /* decorativo */
}

/* Espaço interno no input */
.input-com-icone-direita {
  padding-right: 44px;
}

/* RESPONSIVIDADE MOBILE */
@media (max-width: 768px) {

  .titulo-sessao {
    font-size: 14px !important;
    font-weight: bold !important;
  }


}

</style>
